import { Route } from "@angular/router";
import { authGuard, rolesGuard } from "@core/guards";
import EdgeTransactionsComponentPage from "./components/edge-transactions-page/edge-transactions.component-page";

export function getSuperusersRoutes(): Route[] {
  return [
    {
      path: 'superuser',
      canActivate: [
        authGuard,
        () => rolesGuard(['superuser'], '/companies')
      ],
      canActivateChild: [
        authGuard,
        () => rolesGuard(['superuser'], '/companies')
      ],
      children: [
        {
          title: 'Me',
          path: 'me',
          loadComponent: () => import('./components/me-page/me-page.component')
        },
        {
          title: 'Edge Transactions',
          path: 'edge-transactions',
          component: EdgeTransactionsComponentPage,
        },
      ]
    }
  ];
}
